import React from 'react';
import { ConnectedFieldHeader } from './FragmentHeader/FieldHeader';
import { ConnectedFaresTrackingCalculator } from '../../../components/Calendar/Context/FaresTrackingCalculator';
import { FieldHeaderPrisma } from './FragmentHeader/FieldHeaderPrisma';
import { ABUtils } from '../../../utils';

export const DatesFragmentHeader = () => {
    const { isCssVariationMobile } = ABUtils.getABs();
    return (
        <React.Fragment>
            {!isCssVariationMobile && (
                <ConnectedFieldHeader />
            )}
            {isCssVariationMobile && (
                <ConnectedFaresTrackingCalculator trackType='close_calendar'>
                    {({ extraTracking })=>(
                        <FieldHeaderPrisma
                            textKey="flightsManager.placeholder.date.main"
                            extraTracking={extraTracking}
                        />
                    )}
                </ConnectedFaresTrackingCalculator>
            )}
        </React.Fragment>
    );
};
